<template>
  <v-layout align-center justify-center row fill-height wrap>
    <v-flex xs9 sm4 md3 lg3 xl2>
      <div class="image-container">
        <img src="@/assets/maple-logo.png" class="image"/>
      </div>
      <v-form @submit.prevent="login" novalidate>
        <v-text-field
          v-model="email"
          label="E-mail"
          :rules="[rules.required, rules.email]"
          ml-1 required
          data-test="email"
        />
        <v-text-field
          v-model="password"
          :append-icon="showPassword ? 'visibility_off' : 'visibility'"
          :type="showPassword ? 'text' : 'password'"
          :rules="[rules.required]"
          label="Senha"
          @click:append="showPassword = !showPassword"
          data-test="password"
        />
        <v-select v-model="select" :items="items" return-object/>
        <v-btn class="mt-5" block type="submit" :disabled="disabledButton" color="primary" data-test="button-login">
          <Spinner :loading="isLoginButtonLoading">Login</Spinner>
        </v-btn>
        <div class="link mt-3">
          <a :href="forgotPasswordUrl">Esqueci minha senha</a>
        </div>
      </v-form>
    </v-flex>

    <ForcedUpdateDialog
      :visibility="forcedUpdateDialogVisibility"
      :seconds="timeCount"
      @confirm="update"
    />

  </v-layout>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { emailRegex } from '@/helpers/regex'
import { user } from '@/services'
import Spinner from '@/components/Spinner'
import { getFirstRouteFromPermissions } from '@/helpers/routePermissions'
import * as swUpdateHandler from '@/services/swUpdateHandler'
import ForcedUpdateDialog from '@/components/ForcedUpdateDialog'
import { setTimeout } from 'timers'

export default {
  name: 'auth-login',

  components: {
    Spinner,
    ForcedUpdateDialog
  },

  data: () => ({
    items: [
      {
        text: 'Prédio 1',
        value: 1
      },
      {
        text: 'Prédio 2',
        value: 2
      }
    ],
    select: null,
    email: null,
    password: null,
    showPassword: false,
    rules: {
      required: value => !!value || 'Obrigatório',
      email: value => emailRegex.test(value) || 'Invalido.'
    },
    forcedUpdateDialogVisibility: false,
    timeCount: 5
  }),

  computed: {
    ...mapState({
      loginError: state => (state.auth.loginError),
      loginSuccess: state => (state.auth.loginSuccess),
      isLoginButtonLoading: state => (state.auth.isLoginButtonLoading),
      updateExists: state => (state.swUpdate.updateExists)
    }),

    disabledButton () {
      return (
        !this.email ||
        !this.password ||
        !emailRegex.test(this.email) ||
        this.isLoginButtonLoading
      )
    },

    forgotPasswordUrl () {
      return process.env.VUE_APP_AUTH_RECOVER_PASSWORD_URL
    }
  },

  watch: {
    loginError (newValue) {
      if (newValue) {
        this.showSnack(newValue)
      }
    },
    async loginSuccess (newValue) {
      if (newValue) {
        this.$router.push(await getFirstRouteFromPermissions())
      }
    }
  },

  mounted () {
    user.getSelectedBuilding() ? this.select = user.getSelectedBuilding()
      : this.select = this.items[0]

    if (this.updateExists) {
      this.forcedUpdateDialogVisibility = true
      this.runTimeCount()
    }
  },

  methods: {
    ...mapActions({
      doLogin: 'auth/login',
      showSnack: 'snackbar/showSnack'
    }),

    login () {
      const { email, password } = this
      this.doLogin(
        {
          credentials: { email, password },
          selectedBuilding: this.select
        }
      )
    },

    update () {
      swUpdateHandler.postHandler()
    },

    runTimeCount () {
      setTimeout(() => {
        this.timeCount -= 1

        if (this.timeCount !== 0) {
          this.runTimeCount()
        } else {
          this.update()
        }
      }, 1000)
    }
  }
}
</script>

<style lang="stylus" scoped>
  .link
    text-align center
    display block
  .image
    width 100%
    height 100%
    background-position center center
    background-repeat no-repeat
    &-container
      display block
      text-align center
</style>
